import { useTranslation } from "react-i18next";

const LANGS = [
  { code: "en", label: "EN" },
  { code: "pt", label: "PT" },
] as const;

type Props = { tone?: "default" | "overlay" };

const LanguageSwitcher = ({ tone = "default" }: Props) => {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || "en").startsWith("pt")
    ? "pt"
    : "en";

  const styles =
    tone === "overlay"
      ? { wrap: "text-white/50", divider: "text-white/30", active: "text-white", idle: "hover:text-white" }
      : { wrap: "text-muted-foreground", divider: "text-border", active: "text-foreground", idle: "hover:text-foreground" };

  return (
    <div
      className={`ed-eyebrow flex items-center gap-1.5 ${styles.wrap}`}
      role="group"
      aria-label="Language"
    >
      {LANGS.map((lng, i) => (
        <span key={lng.code} className="flex items-center gap-1.5">
          {i > 0 && <span aria-hidden className={styles.divider}>/</span>}
          <button
            type="button"
            onClick={() => current !== lng.code && i18n.changeLanguage(lng.code)}
            aria-pressed={current === lng.code}
            className={`transition-colors duration-200 ${
              current === lng.code ? styles.active : styles.idle
            }`}
          >
            {lng.label}
          </button>
        </span>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
